/* eslint-disable camelcase */

import { http } from '@/services/http'

export default {
  getWorkflowsList({ offset, limit }) {
    return http.get('/workflows', { params: { offset, limit } })
  },
  updateWorkflow({ data, id }) {
    return http.put(`/workflows/${id}`, data)
  },
  createWorkflow(data) {
    return http.post('/workflows', data)
  },
  deleteWorkflow({ id }) {
    return http.delete(`/workflows/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/api/workflow.js